var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-box"},[_c('div',{style:({'height':'100vh','width':'100%'}),attrs:{"id":"geoContainer"}}),_vm._v(" "),_c('el-button',{ref:"backgo",staticClass:"main-cancel",attrs:{"type":"primary"},on:{"click":function($event){return _vm.reportGO()}}},[_vm._v("返回")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5589c234","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/businessm/geoGraphic.vue
// module id = null
// module chunks = 